import { API } from 'src/api';

export const fetchMetaDataFromUrl = async (urlString: string) => {
  try {
    const response = await API.get(`/files/parse-link?url=${urlString}`);
    return response.data;
  } catch (error) {
    console.error('error', error);
    return null;
  }
};
